import PageContainer from '@/common/components/PageContainer'
import withUserPermission from '@/common/components/WithUserPermission'
import { PermissionType } from '@/common/types'
import { PermissionKeys } from '@/modules/manage-member/mappers'
import { useTablePagination } from '@/common/hooks/useTablePaginate'
import { useState, useEffect } from 'react'
import { useDateFilter } from '@/common/hooks/useDateFilter'
import { format, startOfDay, endOfDay } from 'date-fns'
import { useQueryState, parseAsString } from 'nuqs'
import useQueryGetPlayerWithLuckyWheelReceive from '@/modules/manage-player/api/hooks/useQueryGetPlayerWithLuckyWheelReceive'
import PlayerWithLuckyWheelReceiveListing from '@/modules/manage-player/components/PlayerWithLuckyWheelReceive/components/PlayerWithLuckyWheelReceiveListing'

type SortOrder = 'asc' | 'desc' | undefined

function PlayerWithLuckyWheelReceivePage() {
	const { pageSize, currentPage, searchQuery, channelFilter } =
		useTablePagination()
	const { dateFilter, setDateFilter } = useDateFilter()
	const [dateRange, setDateRange] = useQueryState(
		'dateRange',
		parseAsString.withDefault(''),
	)

	useEffect(() => {
		if (!dateFilter.startDate && !dateFilter.endDate && dateRange !== 'all') {
			const today = new Date()
			setDateFilter({
				startDate: format(startOfDay(today), 'yyyy-MM-dd'),
				endDate: format(endOfDay(today), 'yyyy-MM-dd'),
			})
			setDateRange('today')
		}
	}, [
		dateFilter.startDate,
		dateFilter.endDate,
		dateRange,
		setDateFilter,
		setDateRange,
	])

	const [luckyWheelAmountSort, setLuckyWheelAmountSort] =
		useState<SortOrder>('desc')
	const [luckyWheelTimeSort, setLuckyWheelTimeSort] = useState<SortOrder>()

	const handleSort = (columnId: string, order: SortOrder) => {
		if (columnId === 'totalLuckyWheelAmount') {
			setLuckyWheelAmountSort(order)
			setLuckyWheelTimeSort(undefined)
		} else if (columnId === 'totalWithdrawTime') {
			setLuckyWheelTimeSort(order)
			setLuckyWheelAmountSort(undefined)
		}
	}

	const payload = {
		take: pageSize,
		skip: (currentPage - 1) * pageSize,
		phone: searchQuery,
		channelName: channelFilter || undefined,
		startDate: dateFilter.startDate || undefined,
		endDate: dateFilter.endDate || undefined,
		luckyWheelAmountSort,
		luckyWheelTimeSort,
	}

	const { data, isLoading } = useQueryGetPlayerWithLuckyWheelReceive(payload)

	return (
		<PageContainer>
			<PlayerWithLuckyWheelReceiveListing
				data={data?.data || []}
				total={data?.total || 0}
				isLoading={isLoading}
				onSort={handleSort}
			/>
		</PageContainer>
	)
}

const GuardedPlayerWithLuckyWheelReceivePage = withUserPermission(
	PlayerWithLuckyWheelReceivePage,
	{
		permissionType: PermissionType.Read,
		permissionKey: [PermissionKeys.MANAGE_PLAYER],
	},
)

export default GuardedPlayerWithLuckyWheelReceivePage
